import React, { useState } from 'react';
import { Sidebar } from '../components/Sidebar';
import { DashboardHeader } from '../components/dashboard/DashboardHeader';
import { ToolsSection } from '../components/dashboard/ToolsSection';
import { LegalServicesSection } from '../components/dashboard/LegalServicesSection';
import { DocumentHubSection } from '../components/dashboard/DocumentHubSection';
import { RequestCallModal } from '../components/modals/RequestCallModal';
export function Indexv2() {
  const [showRequestCallModal, setShowRequestCallModal] = useState(false);
  // Mock data - in a real app this would come from the user's subscription/plan
  const userCategories = ['Business', 'HR'];
  const handleRequestCall = () => {
    setShowRequestCallModal(true);
  };
  return <div className="flex h-screen bg-slate-50" data-id="element-1898">
      <Sidebar data-id="element-1899" />
      <div className="flex-1 overflow-auto" data-id="element-1900">
        <DashboardHeader categories={userCategories} data-id="element-1901" />
        <main className="p-6" data-id="element-1902">
          <div className="grid grid-cols-1 gap-6 mb-6" data-id="element-1903">
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-1904">
              <ToolsSection data-id="element-1905" />
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-1906">
              <div className="mb-4" data-id="element-1907">
                <h2 className="text-lg font-semibold text-gray-800" data-id="element-1908">
                  Document Hub
                </h2>
                <p className="text-sm text-gray-600" data-id="element-1909">
                  Centralized document management and organization.
                </p>
              </div>
              <DocumentHubSection data-id="element-1910" />
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-1911">
              <div className="mb-4" data-id="element-1912">
                <h2 className="text-lg font-semibold text-gray-800" data-id="element-1913">
                  Legal Services
                </h2>
                <p className="text-sm text-gray-600" data-id="element-1914">
                  A-la-cart legal services tailored to your needs.
                </p>
              </div>
              <LegalServicesSection onRequestCall={handleRequestCall} data-id="element-1915" />
            </div>
          </div>
        </main>
      </div>
      {showRequestCallModal && <RequestCallModal onClose={() => setShowRequestCallModal(false)} data-id="element-1916" />}
    </div>;
}